import { isString } from 'lodash'
import React, { useContext } from 'react'

import FieldContext from './FieldContext'

/**
 * WARNING: overwritePrefix is REQUIRED when using FieldArray!
 */
type TFieldContextProvider = {
  children?: React.ReactNode
  prefix?: string
  name?: string
  overwritePrefix?: boolean
}
const FieldContextProvider = (
  props: TFieldContextProvider,
): React.ReactElement => {
  const {
    children,
    prefix: propPrefix1,
    name: propPrefix2,
    overwritePrefix,
  } = props

  const innerPrefix = propPrefix1 || propPrefix2

  const { prefix: outerPrefix } = useContext(FieldContext)

  // Append to previous prefix
  let prefix = innerPrefix
  if (innerPrefix && outerPrefix && !overwritePrefix) {
    prefix = `${outerPrefix}.${innerPrefix}`
  }

  // Kill invalid starting dot
  if (isString(prefix) && prefix.startsWith('.')) {
    prefix = prefix.substring(1)
  }

  return (
    <FieldContext.Provider value={{ prefix }}>{children}</FieldContext.Provider>
  )
}

export default FieldContextProvider
